import React, { useState } from "react"

import { AnchorLink } from "gatsby-plugin-anchor-links"
import Container from "react-bootstrap/Container"
import { GMFleetLink } from "../../constants/links"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import logoFleet from "../../images/gmfleet-logo.svg"
import styles from "./navbar.module.css"
import { useTranslation } from "react-i18next"

export default function NavBar({ classVariant, logo }) {
  const [isOpenMenu, setIsOpenMenu] = useState(false)

  const { t, i18n } = useTranslation()

  const header = t("header")
  const renderHeader = []

  const AnchorLinkClick = url => {
    const lang = i18n.language

    if (lang === "en" && url === "/ayuda/#faq") {
      i18n.changeLanguage("es")
    }
  }

  for (const item of header) {
    let link

    if (item.url.includes("#")) {
      link = (
        <AnchorLink
          to={item.url}
          title={item.text}
          className={styles.navBarLink}
          onAnchorLinkClick={() => AnchorLinkClick(item.url)}
        >
          {item.text}
        </AnchorLink>
      )
    } else {
      link = (
        <Nav.Link href={item.url} className={styles.navBarLink}>
          {item.text}
        </Nav.Link>
      )
    }
    renderHeader.push(link)
  }

  const toggleMenu = () => {
    setIsOpenMenu(!isOpenMenu)
  }

  return (
    <Navbar
      className={`${styles.navBar} ${classVariant ? styles[classVariant] : ""}`}
      expand="md"
      bg="dark"
      variant="dark"
      role="navigation"
    >
      <Container fluid="md">
        <Navbar.Brand href="/">
          <img src={logo} className={styles.logo} alt="Gasolina Móvil" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className={`${styles.navBarToggle} ${
            isOpenMenu ? styles.navBarToggleOpen : ""
          }`}
          onClick={toggleMenu}
        />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className={styles.navBarCollapse}
        >
          <Nav className="ml-auto">
            {renderHeader}
            <a
              href={GMFleetLink}
              target="_blank"
              rel="noreferrer nofollow"
              className={styles.navBarLink}
            >
              <img
                src={logoFleet}
                className={styles.logoFleet}
                alt="Gasolina Móvil Fleet"
              />
            </a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
